/**
 * Initial state factory for the "popup" Vuex module.
 *
 * Returned as a function (rather than a plain object) so Vuex gets a fresh,
 * unshared state tree per store instantiation. Each `showX` flag toggles a
 * specific modal's visibility, while `modalData`/`replyPostData`/`quotePostData`
 * hold the payload shown inside the corresponding modal. Note: `modalOrgData`
 * is written by the `setModalData` mutation but is not initialized here.
 */
export default () => ({
  showModal: false,
  showOrgModal: false,
  showModalDraft: false,
  showModalReply: false,
  modalData: {},
  replyPostData: {},
  quotePostData: {},
  showModalAboutUs: false,
});
